import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { FormChecklistTemplate } from 'graphql-common';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import Trans from '@lib/components/Trans/Trans';
import useModalManagement, { Modals } from '@lib/hooks/useModalManagement';
import { useTableItemsBulkSelect } from '@lib/hooks/useTableItemsBulkSelect';
import getStatusFromError from '@lib/utils/getStatusFromError';
import ErrorPage from '@lib/components/ErrorPage/ErrorPage';
import ConfirmationModal from '@lib/components/ConfirmationModal/ConfirmationModal';
import { IconName } from '@lib/components/Modal/enums';
import ChecklistsList from 'routes/FormChecklists/components/ChecklistsList/ChecklistsList';
import useFormChecklistsActions from './utils/useFormChecklistsActions';

const modals = [Modals.DestroyModal];

export default function FormChecklists() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const useBulkSelectResult = useTableItemsBulkSelect<FormChecklistTemplate>();
  const useModalManagementResult = useModalManagement(modals, () =>
    useBulkSelectResult.handleSelectSingleTableItem(null),
  );
  const useActionsResult = useFormChecklistsActions({
    useModalManagementResult,
    useBulkSelectResult,
  });

  const { isModalOpened } = useModalManagementResult;
  const { listQuery, onConfirmedDelete, onCloseDestroyModal } =
    useActionsResult;

  return (
    <>
      <BreadCrumbs data={getBreadCrumbsDataByKey({ pathname, t })} />
      {listQuery.error ? (
        <ErrorPage
          status={getStatusFromError(listQuery.error)}
          description={listQuery.error?.message}
        />
      ) : (
        <ChecklistsList useActionsResult={useActionsResult} />
      )}
      <ConfirmationModal
        confirmButtonLabel={t('yes-delete')}
        description={<Trans i18nKey="delete-checklist-text" />}
        icon={IconName.Delete}
        isOpen={isModalOpened(Modals.DestroyModal)}
        onClose={onCloseDestroyModal}
        onConfirm={onConfirmedDelete}
        title={t('are-you-sure')}
      />
    </>
  );
}
